var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ right:  _vm.rightOriented, left: !_vm.rightOriented},style:({background: _vm.color}),attrs:{"id":"headlineBox"}},[_c('span',[_vm._v(_vm._s(_vm.value))]),_c('div',{staticClass:"addTitle"},[_vm._v(_vm._s(_vm.addTitle))])])}
var staticRenderFns = []

export { render, staticRenderFns }